var _LowQualityIndicator, _LowQualityIndicator2;
import { Fragment } from 'react';
import cn from 'classnames';
import Settings from '@crehana/icons/outline/Settings';
import { useResponsiveContext } from "../../context/Responsive";
import { useTranslation } from "../../hooks";
import ControlButton from "./ControlButton";
import LowQualityIndicator from "./LowQualityIndicator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SettingsButton = function SettingsButton(_ref) {
  var onClick = _ref.onClick,
    currentQuality = _ref.currentQuality,
    hasLowQuality = _ref.hasLowQuality,
    isInBottomControls = _ref.isInBottomControls,
    className = _ref.className;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    className: cn('bg-transparent focus:outline-none flex items-center', className),
    onClick: onClick,
    "aria-label": t('SETTINGS_LABEL'),
    children: [currentQuality && /*#__PURE__*/_jsx("span", {
      className: "font-label text-base-lighter mr-8",
      children: currentQuality
    }), isInBottomControls ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ControlButton, {
        icon: {
          component: Settings
        },
        isSm: playerSize.value === 'sm'
      }), hasLowQuality && (_LowQualityIndicator || (_LowQualityIndicator = /*#__PURE__*/_jsx(LowQualityIndicator, {
        className: "ml-4"
      })))]
    }) : /*#__PURE__*/_jsxs(Fragment, {
      children: [hasLowQuality && (_LowQualityIndicator2 || (_LowQualityIndicator2 = /*#__PURE__*/_jsx(LowQualityIndicator, {
        className: "mr-4"
      }))), /*#__PURE__*/_jsx(ControlButton, {
        icon: {
          component: Settings
        },
        isSm: playerSize.value === 'sm'
      })]
    })]
  });
};
export default SettingsButton;